import { useState, useContext, useEffect } from "react";
import ReactGA from "react-ga4";
import { Grid } from "@mui/material";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Header from "./components/Header";
import QuestionGroups from "./components/QuestionGroups.js";
import QuestionList from "./components/QuestionList";
import WorkSpace from "./components/WorkSpace";
import QuestionDialog from "./components/QuestionDialog";

import { EventContext } from "../../contexts/EventContext.js";
import ProfileQuestionContext from "../../contexts/ProfileQuestionContext.js";

import request from "../../utilities/requests.js";

const ProfileQuestions = () => {
  const { userData } = useContext(EventContext);
  const [org, setOrg] = useState(null);
  const [orgList, setOrgList] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionGroups, setQuestionGroups] = useState([]);
  const [questionGroup, setQuestionGroup] = useState(null);
  const [questionGroupQuestions, setQuestionGroupQuestions] = useState([]);
  const [questionDialogOpen, setQuestionDialogOpen] = useState(false);
  const [editQuestionData, setEditQuestionData] = useState(null);
  const [requiredQuestions, setRequiredQuestions] = useState([]);
  const [questionGroupMessage, setQuestionGroupMessage] = useState("");

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/profilequestions",
      title: "ProfileQuestions",
    });
  }, []);

  useEffect(() => {
    const getOrgs = async () => {
      const result = await request("orgs");
      if (result.success) {
        setOrgList(result.orgs);
      }
    };
    if (!org) {
      setOrg(userData?.org?._id);
      if (userData) {
        if (userData.role === "superadmin" && orgList.length === 0) {
          getOrgs();
        }
      }
    }
  }, [userData]);

  const getQuestions = async () => {
    let url;
    if (!org) {
      url = "profilequestions";
    } else {
      url = `profilequestions?orgId=${org}`;
    }
    const result = await request(url);
    if (result.success) {
      setAllQuestions(result.questions);
      const ids = new Set(questionGroupQuestions.map((q) => q._id));
      setQuestions(result.questions.filter((q) => !ids.has(q._id)));
      // setQuestions(result.questions);
    }
  };

  const getQuestionGroups = async () => {
    let url = "questiongroups";
    if (org) {
      url = url + `?orgId=${org}`;
    }
    const result = await request(url);
    if (result.success) {
      setQuestionGroups(result.questionGroups);
      console.log("***");
      result.questionGroups.map((g) => console.log(g._id));
    }
  };

  useEffect(() => {
    if (org) {
      getQuestions();
      getQuestionGroups();
    }
  }, [org]);

  useEffect(() => {
    const ids = new Set(questionGroupQuestions.map((q) => q._id));
    setQuestions(questions.filter((q) => !ids.has(q._id)));
  }, [questionGroupQuestions]);

  useEffect(() => {
    if (editQuestionData) {
      setQuestionDialogOpen(true);
    }
  }, [editQuestionData]);

  return (
    <ProfileQuestionContext.Provider
      value={{
        org,
        setOrg,
        orgList,
        allQuestions,
        questions,
        setQuestions,
        questionGroups,
        questionGroup,
        setQuestionGroup,
        questionGroupQuestions,
        setQuestionGroupQuestions,
        questionDialogOpen,
        setQuestionDialogOpen,
        editQuestionData,
        setEditQuestionData,
        requiredQuestions,
        setRequiredQuestions,
        questionGroupMessage,
        setQuestionGroupMessage,
      }}
    >
      <DndProvider backend={HTML5Backend}>
        <Grid
          container
          style={{ height: "100%" }}
          alignItems="flex-start"
          justifyContent="flex-start"
        >
          <Grid item xs={12}>
            <Header />
          </Grid>
          <Grid item xs={12}>
            <QuestionGroups
              clear={() => setQuestions(allQuestions)}
              refresh={getQuestionGroups}
            />
          </Grid>
          <Grid item xs={12} style={{ height: "100%" }}>
            <Grid
              container
              direction="row"
              spacing={3}
              justifyContent="flex-start"
              style={{ height: "100%", padding: 20 }}
            >
              <Grid item md={6} xs={6}>
                <QuestionList />
              </Grid>
              <Grid item md={6} xs={6}>
                <WorkSpace refresh={getQuestionGroups} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <QuestionDialog refresh={getQuestions} />
      </DndProvider>
    </ProfileQuestionContext.Provider>
  );
};

export default ProfileQuestions;
